import {
  CampaignRunScheduleBlock,
  type CampaignRunScheduleBlockProps,
} from "./CampaignRunScheduleBlock";

type GuidedScheduleEditorProps = CampaignRunScheduleBlockProps;

/** Standalone schedule editor (e.g. edit-schedule modal). Create flow uses {@link CampaignRunScheduleBlock} inside {@link GuidedBudgetEditor}. */
export default function GuidedScheduleEditor(props: GuidedScheduleEditorProps) {
  return <CampaignRunScheduleBlock {...props} pickerOpenIconAtStart />;
}
